import type { GameProduct, SwimlaneCategory } from '@patrianna/shared-patrianna-types/store/GameModule'
import type { ILevel } from '@patrianna/shared-patrianna-types/store/UserModule'

import { IS_BRAND_PULSZ } from 'config/brands'
import LevelUpMessage from 'dialogs/LevelUpModal/LevelUpMessage'
import type { TypedThunk } from 'src/store/types'
import { getAllGames } from 'src/utils/loadGameInfoGetInitialProps'
import { saveBingoProducts } from 'store/modules/bingo/actions'
import { openSnackbar } from 'store/modules/snackbar/actions'

import { getAllGamesProductsSelector } from './selectors'
import { actions } from './slice'

export const { saveAllGames, saveGameProducts, setLoading } = actions

export const saveGamesProductsFromCategories =
  (categories: Array<SwimlaneCategory>): TypedThunk =>
  (dispatch) => {
    const products = categories.map((category) => category.products)
    const concatedProducts = products.flat()

    const games = concatedProducts.reduce((acc, current) => {
      if (!acc.find((el) => el.code === current.code)) {
        acc.push(current)
      }

      return acc
    }, [])

    // TODO: looks like it's not being used
    if (process.env.BRAND === 'pulszbingo') {
      const bingoCategoryProducts = categories.find((el) => el.type === 'bingo')?.products
      dispatch(saveBingoProducts({ products: bingoCategoryProducts }))
    }

    dispatch(saveGameProducts({ games }))
  }

export const getAllProducts =
  (): TypedThunk =>
  (dispatch, getState, { errorHandler }) => {
    dispatch(setLoading(true))
    getAllGames()
      .then((products) => {
        dispatch(saveAllGames(products))
      })
      .catch((err) => {
        dispatch(
          errorHandler(err, {
            type: 'getAllProducts',
            url: `/v1/get-all-products?brandName=${process.env.BRAND_NAME}`,
            browser: typeof window === 'undefined' ? 'no' : 'yes',
          }),
        )
      })
      .finally(() => dispatch(setLoading(false)))
  }

export const addUnlockedGames =
  (ulockedGames: Array<GameProduct>): TypedThunk =>
  (dispatch, getState) => {
    const allGames = getAllGamesProductsSelector(getState())
    const concatedGames = allGames.map((game) => {
      if (ulockedGames && ulockedGames.find((it) => it.code === game.code)) {
        return {
          ...game,
          unlocked: true,
        }
      }

      return {
        ...game,
      }
    })
    dispatch(saveGameProducts({ games: concatedGames }))
  }

export const levelUpPULSZHandler =
  (levelInfo: ILevel): TypedThunk =>
  (dispatch) => {
    dispatch(
      openSnackbar({
        message: LevelUpMessage,
        positionVertical: 'top',
        positionHorizontal: 'right',
        isFullScreen: true,
        componentProps: {
          vipPoints: levelInfo.vipPoints,
          bonus: levelInfo.bonus,
          level: levelInfo.level,
        },
      }),
    )
  }

export const levelUpHandler =
  (levelInfo: ILevel): TypedThunk =>
  (dispatch) => {
    if (IS_BRAND_PULSZ) {
      dispatch(levelUpPULSZHandler(levelInfo))
    } else {
      dispatch(
        openSnackbar({
          message: LevelUpMessage,
          autoHide: 1000,
          positionVertical: 'top',
          positionHorizontal: 'right',
          componentProps: {
            vipPoints: levelInfo.vipPoints,
            bonus: levelInfo.bonus,
            level: levelInfo.level,
          },
        }),
      )
    }
  }
